import { EventRole } from '@goldcast/api/backend';

import { State } from '@/studio/checkInStaff/store';

const getters = {
  getCheckInStaff(state: State): EventRole[] {
    return Object.values(state.checkInStaff);
  },
  getCheckInStaffById:
    (state: State) =>
    (checkInStaffId: number): EventRole =>
      state.checkInStaff[checkInStaffId]
};

export default getters;
